import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=7fd7a037&scoped=true&"
import script from "./GoodsInfo.vue?vue&type=script&lang=ts&"
export * from "./GoodsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=7fd7a037&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7a037",
  null
  
)

export default component.exports